import type { StepConfig, StepFormField, FieldValue, FieldValues } from '../../types/workflow';

const maxValues = {
  seconds: 604800,
  minutes: 10080,
  hours: 168,
  days: 7,
};

const wait: StepConfig = {
  // Design
  icon: 'wait',
  headerTextColor: '#9C27B0',
  headerColor: '#F3E5F5',
  title: 'Wait',
  text: 'It takes time to wait',
  category: 'Node',
  desc: 'Allows a wait time to be defined before contact proceeds so the next step',
  primaryKey: '{{value}} {{unit}}',

  // Form
  formFields: [
    {
      key: 'value',
      label: 'Wait For',
      type: 'number',
      defaultValue: 1,
      placeholder: 'Enter the wait time',
      dependsOn: ['unit'],
      validation: {
        required: true,
        numeric: true,
        integer: true,
        minValue: 1,
        maxValue: maxValues.seconds,
      },
    },
    {
      key: 'unit',
      label: 'Unit',
      type: 'select',
      defaultValue: 'minutes',
      options: [
        { label: 'Second', value: 'seconds' },
        { label: 'Minute', value: 'minutes' },
        { label: 'Hour', value: 'hours' },
        { label: 'Day', value: 'days' },
      ],
      onChange: (value: FieldValue, allValues: FieldValues, allFields: Record<string, StepFormField>) => {
        const unit = allValues.unit;
        if (typeof unit === 'string') {
          const max = maxValues[(unit as keyof typeof maxValues) || 'seconds'];
          if (allFields.value.validation) {
            allFields.value.validation.maxValue = max;
          }
        }
      },
    },
  ],
};

export default wait;
